import VerticalTabs from "components/Molecules/VerticalTabs"
import { useVehicleManagementVehicleDetailsQuery } from "generated/graphql"
import React, { useState } from "react"
import Certifications from "./details/Certifications"
import Contract from "./details/Contract"
import Owner from "./details/Owner"
import Vehicle from "./details/Vehicle"

const tabs = [
  { id: 1, name: "Information" },
  { id: 2, name: "Certifications" },
  { id: 3, name: "Contract Details" },
  { id: 4, name: "Vehicle Owner" },
  { id: 5, name: "Vehicle Driver" },
]
function VehicleDetails({ id }) {
  const [tab, setTab] = useState(tabs[0])
  const { data } = useVehicleManagementVehicleDetailsQuery({
    variables: { id },
  })
  const vehicle = data?.vehicleDetails
  //
  return (
    <section className="vt-vehicle-details-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-3">
          <div className="tabs">
            <VerticalTabs
              renderTab={tab => tab?.name}
              items={tabs}
              selectedTab={tab}
              onSelect={tab => setTab(tab)}
            />
          </div>
        </div>
        <div className="col-span-9">
          {tab === tabs[0] ? (
            <Vehicle vehicleDetails={vehicle} />
          ) : tab === tabs[1] ? (
            <Certifications />
          ) : tab === tabs[2] ? (
            <Contract
              vehicleId={vehicle?.id}
              contracts={vehicle?.contracts}
              vehicle={vehicle}
            />
          ) : tab === tabs[3] ? (
            <>
              {vehicle?.owner?.id ? (
                <Owner
                  vehicle={vehicle}
                  type="owner"
                  ownerId={vehicle?.owner?.id}
                />
              ) : (
                <p> No Owner Assigned</p>
              )}
            </>
          ) : (
            <>
              {vehicle?.driver?.id ? (
                <Owner
                  vehicle={vehicle}
                  type="driver"
                  ownerId={vehicle?.driver?.id}
                />
              ) : (
                <p> No Driver Assigned</p>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  )
}
export default VehicleDetails
